import React, { Component } from 'react';
import { graphql, compose, withApollo } from 'react-apollo';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import _ from 'lodash';

import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';
import Loading from '../../common/Loading';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import insertEvaluacion from '../../../graphql/mutations/violenciaGenero/insertEvaluacion.graphql';
import insertCasoViolencia from '../../../graphql/mutations/violenciaGenero/insertCasoViolencia.graphql';

import moment from 'moment';

const confirm = Modal.confirm;
const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertEvaluacion, {
    name: 'insertEvaluacion',
  }),
  graphql(insertCasoViolencia, {
    name: 'insertCasoViolencia',
  }),
  graphql(getUsuario)
)
class GenerarCaso extends Component {
  state = {
    loading: false,
    victima: {},
    denunciante: {},
    agresores: [],
    step: 0,
    evaluacion: {},
    requeridoDNI: true,
  };

  guardarDenunciante = persona => {
    this.setState(
      {
        denunciante: {
          ...this.state.denunciante,
          ...persona,
        },
      },
      function() {
        let yo = this;
        confirm({
          title: 'La denunciante es la victima?',
          content: 'Confirme si es la misma persona',
          okText: 'Si',
          okType: 'primary',
          cancelText: 'No',
          onOk() {
            // console.log("Es la misma persona");
            //Si es lo mismo, avanzo 2 veces y ya guardo la persona.
            yo.setState(
              {
                ...yo.state,
                step: yo.state.step + 2,
                victima: yo.state.denunciante,
              },
              () => {
                // console.log(yo.state.victima);
                confirm({
                  title: 'Conoce el Documento del Agresor?',
                  content:
                    'En caso de no conocerlo, podra agregar menos datos.',
                  okText: 'Si',
                  okType: 'primary',
                  cancelText: 'No',
                  onOk() {
                    yo.setState({
                      requeridoDNI: true,
                    });
                  },
                  onCancel() {
                    yo.setState({
                      requeridoDNI: false,
                    });
                  },
                });
              }
            );
          },
          onCancel() {
            //Sino, debo cargarla
            yo.siguientePaso();
          },
        });
      }
    );
  };

  guardarVictima = persona => {
    this.setState(
      {
        victima: {
          ...this.state.victima,
          ...persona,
        },
      },
      function() {
        this.siguientePaso();
      }
    );
  };

  randomString = (length, chars) => {
    var result = '';
    for (var i = length; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)];
    // console.log('RESULTADO ES: ', result);
    return result;
  };

  guardarAgresor = persona => {
    let agresores = this.state.agresores;
    delete persona.__typename;
    delete persona.fecha_ultimo_cambio;
    // console.log('PERSONA ES: ', persona);
    if (!persona.tipo_doc && !persona.num_doc) {
      //Esto significa que la persona no tiene ID, por lo tanto, no es traida de base, por lo que le vamos a asignar uno
      var rString = this.randomString(
        16,
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      );
      persona._id = rString;
    }
    agresores.push(persona);
    this.setState(
      {
        agresores: agresores,
      },
      function() {
        let yo = this;
        confirm({
          title: 'Quiere continuar cargando agresores?',
          content: 'Si desea ir al paso siguiente, presione el boton NO.',
          okText: 'Si',
          okType: 'primary',
          cancelText: 'No',
          onOk() {
            // console.log('Sigo cargando agresores....');
            confirm({
              title: 'Conoce el Documento del Agresor?',
              content: 'En caso de no conocerlo, podra agregar menos datos.',
              okText: 'Si',
              okType: 'primary',
              cancelText: 'No',
              onOk() {
                yo.setState({
                  requeridoDNI: true,
                });
              },
              onCancel() {
                yo.setState({
                  requeridoDNI: false,
                });
              },
            });
          },
          onCancel() {
            // console.log('Los agresores quedan...');
            // console.log(yo.state.agresores);
            yo.insertarCaso();
          },
        });
      }
    );
  };

  recibirEvaluacion = evaluacion => {
    this.setState(
      {
        ...this.state,
        evaluacion,
      },
      () => {
        this.props
          .insertEvaluacion({
            variables: {
              evaluacion,
            },
          })
          .catch(err => {
            console.log('Ocurrio un error a la hora de crear la evaluacion');
            console.log(err);

            Modal.error({
              title: 'Error a la hora de crear la evaluacion',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  };

  insertarCaso = () => {
    // console.log('entreeeee %%%%%% entreeeee %%%%%% entreeee %%%%%%%');
    let idAgresores = [];
    _.forEach(this.state.agresores, agresor => {
      idAgresores.push(agresor._id);
    });

    let caso = {
      idVictima: this.state.victima._id,
      idDenunciante: this.state.denunciante._id,
      // idAgresores: idAgresores,
      agresores: this.state.agresores,
      idOrganismo: this.props.data.getUsuario.organismo._id,
    };

    this.props
      .insertCasoViolencia({
        variables: {
          casoViolencia: caso,
        },
      })
      .then(respuestaCaso => {
        notification.success({
          message: 'Caso de Violencia de Genero Generado',
          description:
            'Se registro correctamente los datos del caso en la base de datos',
        });

        this.setState(
          {
            ...this.state,
            _id: respuestaCaso.data.insertCasoViolencia._id,
            organismo: respuestaCaso.data.insertCasoViolencia.organismo,
          },
          () => {
            // this.siguientePaso();
            this.props.history.push(
              '/violenciaGenero/caso/' +
                respuestaCaso.data.insertCasoViolencia._id
            );
          }
        );
      })
      .catch(err => {
        console.log('Error a la hora de crear el caso de violencia de genero.');
        console.log(err);

        Modal.error({
          title: 'Error a la hora de crear el caso de violencia de genero',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  generarDatos = () => {
    // console.log("Estoy por generar los datos para enviar a la decision");

    let datos = {
      victima: {
        ...this.state.victima,
        fecha_nacimiento: this.state.victima.fecha_nacimiento
          ? moment(this.state.victima.fecha_nacimiento).format('DD/MM/YYYY')
          : '',
        edad: this.state.victima.fecha_nacimiento
          ? Math.floor(
              moment(new Date()).diff(
                moment(this.state.victima.fecha_nacimiento),
                'years',
                true
              )
            )
          : '',
      },
      denunciante: {
        ...this.state.denunciante,
        fecha_nacimiento: this.state.denunciante.fecha_nacimiento
          ? moment(this.state.denunciante.fecha_nacimiento).format('DD/MM/YYYY')
          : '',
        edad: this.state.denunciante.fecha_nacimiento
          ? Math.floor(
              moment(new Date()).diff(
                moment(this.state.denunciante.fecha_nacimiento),
                'years',
                true
              )
            )
          : '',
      },
      // evaluacion: {
      //   ...this.state.evaluacion,
      // },
      _id: this.state._id,
      organismo: {
        ...this.state.organismo,
      },
    };

    // console.log("Datos a enviar: ");
    // console.log(datos);
    return datos;
  };

  onCancel = () => {
    // console.log("Cancelar total.");

    this.setState(
      {
        loading: false,
        victima: {},
        agresores: [],
        step: 0,
        evaluacion: {},
      },
      () => {
        // console.log("ESTADO REINICIADO");
        // console.log(this.state);
        this.props.history.push('/');
      }
    );
  };

  siguientePaso = () => {
    // console.log("PASO SIGUIENTE");

    //Metodo que se encarga de aumentar en 1 el paso y es llamado por todos los metodos auxiliares
    let paso = this.state.step;
    paso++;
    let yo = this;
    this.setState(
      {
        ...this.state,
        step: paso,
      },
      () => {
        if (this.state.step == 2) {
          //Pregunto si se conoce el DNI de la victima
          confirm({
            title: 'Conoce el Documento del Agresor?',
            content: 'En caso de no conocerlo, podra agregar menos datos.',
            okText: 'Si',
            okType: 'primary',
            cancelText: 'No',
            onOk() {
              yo.setState({
                requeridoDNI: true,
              });
            },
            onCancel() {
              yo.setState({
                requeridoDNI: false,
              });
            },
          });
        }
      }
    );
  };

  anteriorPaso = () => {
    // console.log("PASO ANTERIOR");

    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  // eslint-disable-next-line no-unused-vars
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      loading: false,
      victima: {},
      agresores: [],
      step: 0,
      evaluacion: {},
    });
  }

  render() {
    const { Step } = Steps;
    let { step, loading } = this.state;

    if (loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Violencia de Genero</Breadcrumb.Item>
          <Breadcrumb.Item>Evaluar Caso</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> GENERAR CASO
          </h2>
          <br />
          <Steps size="small" className="stepsFormularios" current={step}>
            <Step title="Buscar Denunciante" />
            <Step title="Buscar Victima" />
            <Step title="Buscar Agresor" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <BuscarYCrearPersona obtenerPersona={this.guardarDenunciante} />
            )}
            {step === 1 && (
              <BuscarYCrearPersona obtenerPersona={this.guardarVictima} />
            )}
            {step === 2 && (
              <BuscarYCrearPersona
                obtenerPersona={this.guardarAgresor}
                multiple={true}
                onFinish={this.insertarCaso}
                requeridoDNI={this.state.requeridoDNI}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(GenerarCaso);
